<template>
  <div>
    <!-- header -->
    <Header></Header>

    <div class="sub-wrapper">
      <div class="title-bg global">
        <div class="container inner">
          <p>글로벌 역량</p>
          <p>
            글로벌 역량 강화 과정은<br />
            커뮤케이션 및 비즈니스 스킬, 글로벌직무 역량 향상을<br />중점으로
            최상의 교육을 제공합니다.
          </p>
          <p class="pointer" @click="goInquiry">교육 문의하기</p>
        </div>
      </div>
      <ul class="pdf-wrapper">
        <li id="content01">
          <div class="container inner">
            <div class="img-wrapper">
              <img src="@/assets/img/newGlobal/sub/global/01.png" alt="img" />
            </div>
            <div class="text-wrapper">
              <p>
                In-House Language Training<br />(일반 / 비즈니스 회화 정규과정)
              </p>
              <div class="line"></div>
              <p>
                In-House Language과정은 성공적인 비즈니스 업무 수행을 위한 영어
                및 제2외국어 중심의 맞춤 프로그램을 제공합니다.
              </p>
              <ul>
                <li>체계적인 교육과정 설계 프로세스 (레벨테스트 및 분석)</li>
                <li>
                  성공적인 글로벌 비즈니스 수행을 위한 실무 외국어 능력 향상
                </li>
                <li>
                  현업 중심 비즈니스 성과에 기여하는 글로벌 커뮤니케이션 능력
                  습득
                </li>
                <li>
                  현지 문화 및 상황별 소통 학습을 통하여 유연하게 대처할 수 있는
                  자신감과 Communication Skill 향상
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[0])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content02">
          <div class="container inner">
            <div class="img-wrapper">
              <img src="@/assets/img/newGlobal/sub/global/02.png" alt="img" />
            </div>
            <div class="text-wrapper">
              <p>
                1:1 Co-Active Learning<br />(시뮬레이션 기반 학습자 참여형
                프로그램)
              </p>
              <div class="line"></div>
              <p>
                Task (Simulation) 기반의 학습자 참여형 수업으로, 인지행동 치료
                방식의 Power Feedback Clinic을 적용하여 빠르고 정확한 교정
                중심의 프리미엄 클래스입니다.
              </p>
              <ul>
                <li>1:1 Co-Active Learning 전문 강사진</li>
                <li>
                  개인별 수요도 조사를 통한 맞춤 학습설계 제공 (Learning by
                  Objective 설정)
                </li>
                <li>Simulation Based 행동교정 진행</li>
                <li>
                  ELP (초과학습 센터) 운영, 학습방법 동영상 제공, 스마일 시트를
                  통해 학습자의 주간 반응 체크
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[1])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content03">
          <div class="container inner">
            <div class="img-wrapper">
              <img src="@/assets/img/newGlobal/sub/global/03.png" alt="img" />
            </div>
            <div class="text-wrapper">
              <p>Language Lab Course<br />(신개념 1:1 맞춤 코칭 과정)</p>
              <div class="line"></div>
              <p>
                짧지만 나만을 위한 1:1 맞춤 수업, 1:1 집중 Clinic을 통한 개인별
                맞춤 코칭 과정입니다.
              </p>
              <ul>
                <li>고객 맞춤형 교육설계 시스템 (20분, 30분, 1시간)</li>
                <li>학습자 Needs에 맞춘 LBO 설정과 교육 프로그램 제공</li>
                <li>
                  체계적 교육 진행을 위한 Language Lab 전용 System Note 제공
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[2])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content04">
          <div class="container inner">
            <div class="img-wrapper">
              <img src="@/assets/img/newGlobal/sub/global/04.png" alt="img" />
            </div>
            <div class="text-wrapper">
              <p>
                Global Business Skill Workshop<br />(글로벌 비즈니스 스킬
                워크샵)
              </p>
              <div class="line"></div>
              <p>
                글로벌 비즈니스 환경에서 효과적인 커뮤니케이션을 통한 글로벌
                경쟁력 강화와 글로벌 리더를 육성합니다.
              </p>
              <ul>
                <li>Business Presentation Skill</li>
                <li>Business Writing Skill</li>
                <li>Business Negotiation Skill</li>
                <li>Business Meeting Skill</li>
                <li>Business Conference Call Skill</li>
                <li>Global Leadership Workshop</li>
                <li>Cross-Cultural Understanding & Business Protocol</li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[3])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content05">
          <div class="container inner">
            <div class="img-wrapper">
              <img src="@/assets/img/newGlobal/sub/global/05.png" alt="img" />
            </div>
            <div class="text-wrapper">
              <p>Global Expert Program<br />(글로벌 직무역량 강화 과정)</p>
              <div class="line"></div>
              <p>
                Global Standard 수준의 직무 역량 경쟁력 강화와 산업을 이끄는
                인재 양성을 목표로, 직무 · 산업 별 맞춤과정 운영을 통한 최적의
                학습 효과를 제공합니다.
              </p>
              <ul>
                <li>
                  Global Standard 수준의 직무 역량 경쟁력 강화와 산업을 이끄는
                  인재양성
                </li>
                <li>
                  직무별 및 산업별 실무 영역에서의 Business Communication 능력
                  강화
                </li>
                <li>
                  Global Business 환경에서 효과적인 커뮤니케이션을 통한 경쟁력
                  강화
                </li>
                <li>현업 Case Study를 통한 글로벌 실무역량 강화</li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[4])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content06">
          <div class="container inner">
            <div class="img-wrapper">
              <img src="@/assets/img/newGlobal/sub/global/06.png" alt="img" />
            </div>
            <div class="text-wrapper">
              <p>이공계 영어 논문 역량 향상 과정</p>
              <div class="line"></div>
              <p>
                이공계 영어 논문에 대한 이해와 논문을 읽고 작성하는 방법을
                체계적으로 학습하는 과정입니다.
              </p>
              <ul>
                <li>
                  Impact factor가 높은 논문 검색 방법, 업무 유관 논문 리딩 및
                  핵심 도출법 학습
                </li>
                <li>
                  논문의 기본 구조 및 주요 영문 표현, 한국 연구자들이 흔히
                  실수하는 영문 오류 등에 대한 교육
                </li>
                <li>
                  이공계 SCI급 논문 작성이 성과인 임직원 대상으로 기초부터 논문
                  작성, 피드백까지 제공
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li id="content07">
          <div class="container inner">
            <div class="img-wrapper">
              <img src="@/assets/img/newGlobal/sub/global/07.png" alt="img" />
            </div>
            <div class="text-wrapper">
              <p>Special Intensive Course<br />(기적의 7일 코스)</p>
              <div class="line"></div>
              <p>
                7일만에 기본 의사소통이 가능한! 기적의 학습프로그램 스피킹
                훈련이 극대화된 단기집중 프로그램입니다.
              </p>
              <ul>
                <li>언어별 단기 실력 향상을 위한 최적화 맞춤 프로그램</li>
                <li>7일간 학습자 목표 달성을 위한 특화된 학습법 적용</li>
                <li>
                  영어, 중국어, 베트남어 외 총 14개 언어 기적의 프로그램 운영
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[5])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content08">
          <div class="container inner">
            <div class="img-wrapper">
              <img src="@/assets/img/newGlobal/sub/global/08.png" alt="img" />
            </div>
            <div class="text-wrapper">
              <p>
                Aerospace & Defense Language Course<br />(항공 및 방산 회화
                과정)
              </p>
              <div class="line"></div>
              <p>
                항공 및 방산 분야의 진출을 위한 전문 인력 양성을 목표로, 군사 및
                항공 관련 용어에 대한 이해와 구사능력 향상을 위한 교육 과정을
                제공합니다.
              </p>
              <ul>
                <li>
                  방산 현장에서의 커뮤니케이션 초,중,고급 레벨의 학습자를 위한
                  과정
                </li>
                <li>
                  항공관련 용어에 대한 이해와 구사능력 향상을 위한 직무능력 향상
                  과정
                </li>
                <li>EPTA Test 대비 교육 및 맞춤 컨설팅 제공</li>
              </ul>
              <img
                src="@/assets/img/newGlobal/sub/global/08-1.png"
                alt="img"
                class="img08-1"
              />
            </div>
          </div>
        </li>
        <li id="content09">
          <div class="container inner">
            <div class="img-wrapper">
              <img src="@/assets/img/newGlobal/sub/global/09.png" alt="img" />
            </div>
            <div class="text-wrapper">
              <p>
                Medical & Health Care Training Program<br />(의료보건산업분야
                글로벌 인력양성 프로그램)
              </p>
              <div class="line"></div>
              <p>
                글로벌 환경에서 의료보건산업분야를 선도할 글로벌 핵심인재를
                양성하여, 글로벌 의료보건산업 비즈니스의 성장을 견인하는
                프로그램 입니다.
              </p>
              <ul>
                <li>
                  해당 산업에 따른 맞춤형 교육과정 제공: 글로벌 헬스케어, 병원,
                  제약, 의료기기, 화장품, 4차 산업, 특화
                </li>
                <li>
                  글로벌 업무 수행을 위한 핵심 요소를 도출하여 맞춤형 교육
                  프로그램 제공
                </li>
                <li>
                  교육 컨설팅부터 교육 실행, 사후 관리까지 체계적 관리 운영 제공
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[6])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content10">
          <div class="container inner">
            <div class="img-wrapper">
              <img src="@/assets/img/newGlobal/sub/global/10.png" alt="img" />
            </div>
            <div class="text-wrapper">
              <p>CARROT AI Tutor<br />(AI 신개념 회화 학습 플랫폼)</p>
              <div class="line"></div>
              <p>
                음성 AI 기술과 회화실력 판별 AI 알고리즘을 활용하여
                일상/비즈니스 상황 영어를 대화형 UX로 스스로 학습하는 신개념
                회화 학습!
              </p>
              <ul>
                <li>
                  음성 AI기술이 접목된 인공지능 튜터와 언제 어디서나 영어로 대화
                  가능
                </li>
                <li>
                  회화 수준을 판단하고 자연스러운 대화를 유도하여 회화실력 향상
                </li>
                <li>300여 개의 다양한 상황 별 주제 제시</li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[7])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
      </ul>

      <!-- 문의하기 -->
      <div class="inquiry-container">
        <Inquiry></Inquiry>
      </div>
    </div>

    <!-- footer -->
    <Footer> </Footer>

    <!-- 이미지 뷰 모달 -->
    <ImageView
      v-if="isimgViewVisible"
      @closeImgView="hideImgView"
      :imgP="imageData.imgP"
      :imgM="imageData.imgM"
    ></ImageView>
  </div>
</template>
<script>
import Header from "@/components/NewGlobal/Header.vue";
import Footer from "@/components/NewGlobal/Footer.vue";
import Inquiry from "@/components/NewGlobal/Inquiry.vue";
import ImageView from "@/page/NewGlobal/ImageView.vue";
import "@/assets/style/newGlobalReset.scss";
import "@/assets/style/newGlobalSub.scss";

export default {
  name: "global",
  components: {
    Header,
    Footer,
    Inquiry,
    ImageView,
  },
  mounted() {
    // global header
    // const header = document.querySelector("#header");
    // header.style.display = "none";

    // main header color
    const mainHeader = document.querySelector(".header");
    const introWrapper = document.querySelector(".title-bg").offsetHeight;

    window.addEventListener("scroll", function () {
      if (window.scrollY >= introWrapper) {
        mainHeader.classList.add("active");
      } else {
        mainHeader.classList.remove("active");
      }
    });

    // main mobile nav
    const mtMenu = document.querySelector(".mt-nav");

    const openMenu = document.querySelector(".open-menu");
    openMenu.addEventListener("click", function () {
      mtMenu.style.display = "block";
    });

    const closeMenu = document.querySelector(".close-menu");
    closeMenu.addEventListener("click", function () {
      mtMenu.style.display = "none";
    });

    window.addEventListener("DOMContentLoaded", function () {
      if (screen.width > 1200) {
        mtMenu.style.display = "none";
      }
    });

    window.addEventListener("resize", function () {
      if (screen.width > 1200) {
        mtMenu.style.display = "none";
      }
    });
  },
  data() {
    return {
      list: [
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/global/01_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/global/01_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/global/02_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/global/02_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/global/03_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/global/03_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/global/04_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/global/04_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/global/05_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/global/05_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/global/06_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/global/06_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/global/07_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/global/07_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/global/08_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/global/08_pc.jpg",
        },
      ],

      isimgViewVisible: false,
    };
  },
  methods: {
    goInquiry() {
      document
        .getElementById("inqueryTxtArea")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    },

    showImgView(item) {
      this.isimgViewVisible = true;
      this.imageData = {
        imgP: item.imgP,
        imgM: item.imgM,
      };
    },

    hideImgView() {
      this.isimgViewVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
